'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactI18next = require('react-i18next');

var _chemist = require('chemist');

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

var _PaintersOrderSummaryItem = require('./PaintersOrderSummaryItem');

var _PaintersOrderSummaryItem2 = _interopRequireDefault(_PaintersOrderSummaryItem);

var _PaintersOrderSummaryTotals = require('./PaintersOrderSummaryTotals');

var _PaintersOrderSummaryTotals2 = _interopRequireDefault(_PaintersOrderSummaryTotals);

var _OrderSummaryTotals = require('./OrderSummaryTotals');

var _OrderSummaryTotals2 = _interopRequireDefault(_OrderSummaryTotals);

var _OrderSummaryItem = require('./OrderSummaryItem');

var _OrderSummaryItem2 = _interopRequireDefault(_OrderSummaryItem);

var _PromotionCode = require('../PromotionCode');

var _PromotionCode2 = _interopRequireDefault(_PromotionCode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderSummary = (_dec = (0, _reactI18next.translate)(), _dec2 = (0, _chemist.configurable)(), _dec3 = (0, _reactCssModules2.default)(_style2.default, { allowMultiple: true }), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(OrderSummary, _React$Component);

  function OrderSummary() {
    (0, _classCallCheck3.default)(this, OrderSummary);
    return (0, _possibleConstructorReturn3.default)(this, (OrderSummary.__proto__ || (0, _getPrototypeOf2.default)(OrderSummary)).apply(this, arguments));
  }

  (0, _createClass3.default)(OrderSummary, [{
    key: 'toggleText',
    value: function toggleText() {
      var t = this.props.t;

      return this.summaryVisible() ? t('hide') : t('show');
    }
  }, {
    key: 'orderSummaryClass',
    value: function orderSummaryClass() {
      if (!this.props.orderCompletePage) return 'o-orderSummary';

      return 'o-orderSummary o-orderSummary--complete';
    }
  }, {
    key: 'titleClass',
    value: function titleClass() {
      if (!this.props.orderCompletePage) {
        return 'a-orderSummary__title';
      }

      return 'a-orderSummary__title a-orderSummary__title--complete';
    }
  }, {
    key: 'useSummaryToggle',
    value: function useSummaryToggle() {
      if (!this.props.config.store.disableSummaryToggleOnSteps) {
        return true;
      }
      return !this.props.config.store.disableSummaryToggleOnSteps.includes(this.props.step);
    }
  }, {
    key: 'summaryVisible',
    value: function summaryVisible() {
      if (!this.useSummaryToggle()) {
        return true;
      }
      return this.props.orderSummaryVisible;
    }
  }, {
    key: 'promoVisible',
    value: function promoVisible() {
      if (this.props.config.store.disablePromotionsOnAddress) {
        return this.props.step !== 'address';
      }

      return true;
    }
  }, {
    key: 'promotionTotal',
    value: function promotionTotal() {
      var orderTotal = this.props.order.adjustments.reduce(function (total, adjustment) {
        if (adjustment.promotionCode) {
          total -= parseFloat(adjustment.amount);
        }
        return total;
      }, 0);

      var lineItemTotal = this.props.order.lineItems.reduce(function (total, line) {
        return total + line.adjustments.reduce(function (lineTotal, adjustment) {
          if (adjustment.promotionCode) {
            lineTotal -= parseFloat(adjustment.amount);
          }
          return lineTotal;
        }, 0);
      }, 0);

      return orderTotal + lineItemTotal;
    }
  }, {
    key: 'showPromoCode',
    value: function showPromoCode() {
      if (this.props.step === 'payment') return false;
      if (this.props.orderCompletePage) return false;

      if (this.promotionTotal() > 0) {
        return true;
      }

      switch (this.props.tempPromotionsEnabledSet) {
        case 'yes':
          return true;
        case 'no':
          return false;
        default:
      }

      return this.props.config.store.promotionsEnabled;
    }
  }, {
    key: 'renderFlourishHeaders',
    value: function renderFlourishHeaders() {
      var t = this.props.t;

      return _react2.default.createElement(
        'table',
        { styleName: 'm-orderSummaryHeaders desktopOnlyTable' },
        _react2.default.createElement(
          'tbody',
          null,
          _react2.default.createElement(
            'th',
            { styleName: 'm-orderSummaryHeaders__left' },
            t('spree.description')
          ),
          _react2.default.createElement(
            'th',
            { width: '20%', styleName: 'm-orderSummaryHeaders__right' },
            t('spree.total')
          )
        )
      );
    }
  }, {
    key: 'renderPaintersHeaders',
    value: function renderPaintersHeaders() {
      var t = this.props.t;

      return _react2.default.createElement(
        'table',
        { styleName: 'm-orderSummaryHeaders desktopOnlyTable' },
        _react2.default.createElement(
          'tbody',
          null,
          _react2.default.createElement(
            'th',
            { styleName: 'm-orderSummaryHeaders__left' },
            t('spree.description')
          ),
          _react2.default.createElement(
            'th',
            { width: '5%', styleName: 'm-orderSummaryHeaders__right' },
            'Quantity'
          ),
          _react2.default.createElement(
            'th',
            { width: '20%', styleName: 'm-orderSummaryHeaders__right' },
            'Price per item'
          ),
          _react2.default.createElement(
            'th',
            { width: '20%', styleName: 'm-orderSummaryHeaders__right' },
            t('spree.total')
          )
        )
      );
    }
  }, {
    key: 'renderHeaders',
    value: function renderHeaders() {
      if (this.props.config.theme === 'painters') {
        return this.renderPaintersHeaders();
      }

      return this.renderFlourishHeaders();
    }
  }, {
    key: 'renderToggle',
    value: function renderToggle() {
      var _context;

      if (this.props.orderCompletePage) {
        return '';
      }

      if (!this.useSummaryToggle()) {
        return '';
      }

      return _react2.default.createElement(
        'a',
        {
          styleName: 'm-orderSummary__opener',
          className: 'visible-xs',
          title: this.toggleText(),
          onClick: (_context = this.props).onToggle.bind(_context)
        },
        this.toggleText()
      );
    }
  }, {
    key: 'renderTotals',
    value: function renderTotals() {
      if (this.props.config.theme !== 'painters') {
        return _react2.default.createElement(_OrderSummaryTotals2.default, {
          order: this.props.order,
          orderCompletePage: this.props.orderCompletePage
        });
      }

      return _react2.default.createElement(_PaintersOrderSummaryTotals2.default, {
        order: this.props.order,
        orderCompletePage: this.props.orderCompletePage
      });
    }
  }, {
    key: 'renderSummaryItem',
    value: function renderSummaryItem(item, index) {
      if (this.props.config.theme !== 'painters') {
        return _react2.default.createElement(_OrderSummaryItem2.default, (0, _extends3.default)({}, item, {
          index: index,
          key: item.id,
          currency: this.props.order.currency,
          orderCompletePage: this.props.orderCompletePage
        }));
      }

      return _react2.default.createElement(_PaintersOrderSummaryItem2.default, (0, _extends3.default)({}, item, {
        index: index,
        key: item.id,
        currency: this.props.order.currency,
        orderCompletePage: this.props.orderCompletePage
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this,
          _context2;

      var t = this.props.t;


      return _react2.default.createElement(
        'section',
        { styleName: this.orderSummaryClass() },
        _react2.default.createElement(
          'div',
          { styleName: 'm-orderSummary__header' },
          _react2.default.createElement(
            'p',
            { styleName: this.titleClass() },
            t('spree.order_summary')
          ),
          this.renderToggle()
        ),
        _react2.default.createElement(
          'div',
          { styleName: this.summaryVisible() ? 'is-visible' : 'is-hidden' },
          _react2.default.createElement(
            'ul',
            { styleName: 'm-orderSummaryItems' },
            this.props.orderCompletePage && this.renderHeaders(),
            this.props.order.lineItems.map(function (item, index) {
              return _this2.renderSummaryItem(item, index);
            })
          ),
          this.renderTotals()
        ),
        _react2.default.createElement(
          'div',
          { styleName: this.promoVisible() ? 'is-visible' : 'is-hidden' },
          this.showPromoCode() ? _react2.default.createElement(_PromotionCode2.default, {
            currency: this.props.order.currency,
            amount: this.promotionTotal(),
            orderNumber: this.props.order.number,
            step: this.props.step,
            onApply: (_context2 = this.props).onCouponApply.bind(_context2),
            onRemove: (_context2 = this.props).onCouponRemove.bind(_context2)
          }) : ''
        )
      );
    }
  }]);
  return OrderSummary;
}(_react2.default.Component), _class2.propTypes = {
  order: _react.PropTypes.object.isRequired,
  orderCompletePage: _react.PropTypes.bool,
  orderSummaryVisible: _react.PropTypes.bool,
  onToggle: _react.PropTypes.func,
  step: _react.PropTypes.string,
  onCouponApply: _react.PropTypes.func,
  onCouponRemove: _react.PropTypes.func
}, _class2.defaultProps = {
  orderCompletePage: false,
  orderSummaryVisible: false,
  onCouponApply: function onCouponApply() {},
  onCouponRemove: function onCouponRemove() {}
}, _temp)) || _class) || _class) || _class);
exports.default = OrderSummary;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/OrderSummary/index.js
// module id = 596
// module chunks = 0